export const CERTIFICATE_NAME_MAX_LENGTH = 255;
